module.exports = __webpack_public_path__ + "static/media/mother with kids.47a59cbd.jpg";